<template>
  <div id="sshet-basic-details">
    <div class="row">
      <div class="col-xs-12">
        <div class="shadow clearfix">
          <hr class="hr-text" data-content="Details"/>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="sd-bd-property" class="form-label">Property</label>
              <select class="form-control" id="sd-bd-property" v-model="entity.property">
                <option value=""></option>
                <option v-for="opt in properties" :value="opt">{{ opt }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="sd-data-type" class="form-label">Data Type</label>
              <select class="form-control" id="sd-data-type" v-model="entity.dataType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('SPREADSHEET_DATA_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group" v-show="isActualValue">
              <label for="sd-actual" class="form-label">Actual Value</label>
              <select v-if="useDropdownActualValue" class="form-control" id="sd-actual" v-model="entity.actualValue">
                <option value=""></option>
                <option v-for="(opt, i) in actualValueOptions" :value="opt.code">{{ opt.name }}</option>
              </select>
              <input v-else type="text" class="form-control" id="sd-actual" v-model="entity.actualValue"/>
            </div>
            <div class="form-group" v-show="!isActualValue">
              <label for="sd-tab" class="form-label">Tab Name</label>
              <input type="text" class="form-control" id="sd-tab" v-model="entity.tabName"/>
            </div>
            <div class="form-group" v-show="isMainSpreadsheetField">
              <label for="sd-nm" class="form-label">Name</label>
              <input type="text" class="form-control" id="sd-nm" v-model="entity.name"/>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group" v-show="!isActualValue">
              <label for="sd-cell" class="form-label">Cell</label>
              <input type="text" class="form-control" id="sd-cell" v-model="entity.cell"/>
            </div>
            <div v-show="isMainSpreadsheetField">
              <div class="form-group">
                <label for="sd-sr" class="form-label">Start Row</label>
                <input type="text" class="form-control" id="sd-sr" v-model="entity.startRow"/>
              </div>
              <div class="form-group">
                <label for="sd-er" class="form-label">End Row</label>
                <input type="text" class="form-control" id="sd-er" v-model="entity.endRow"/>
              </div>
              <div class="form-group">
                <label for="sd-s-column" class="form-label">Start Column</label>
                <input type="text" class="form-control" id="sd-s-column" v-model="entity.startColumn"/>
              </div>
              <div class="form-group">
                <label for="sd-e-column" class="form-label">End Column</label>
                <input type="text" class="form-control" id="sd-e-column" v-model="entity.endColumn"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
            <div class="pull-right">
              <div class="btn btn-success" @click="save">
                {{ saveOrUpdate }}
              </div>
              <div v-if="entity.id" class="btn btn-warning" @click="doClear">
                Add
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <vue-table
              :tableData="details"
              tableTitle="Details"
              v-on:table-edit-request="updateActive"
              :showEdit="true"
              v-on:table-delete-request="doDelete"
              :showDelete="true"
              :fields="fields"
            ></vue-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import HelperMixin from '../../mixins/Helpers'
  import VueTable from '../../../helpers/VueTable'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import SheetMixin from './SheetMixin'
  export default {
    name: 'SpreadSheetBasicDetails',
    mixins: [ HelperMixin, SheetMixin ],
    components: {
      VueTable
    },
    props: [ 'dets', 'parent', 'properties', 'type' ],
    data () {
      return {
        fields: [
          { header: 'Property', prop: 'property' },
          { header: 'Type', prop: item => this.getDataType(item.dataType) },
          { header: 'Tab', prop: 'tabName' },
          { header: 'Cell', prop: 'cell' },
          { header: 'Value', prop: 'actualValue' },
          { header: 'Start Row', prop: 'startRow', hideByDefault: true },
          { header: 'End Row', prop: 'endRow', hideByDefault: true },
          { header: 'Start Column', prop: 'startColumn', hideByDefault: true },
          { header: 'End Column', prop: 'endColumn', hideByDefault: true }
        ],
        details: [],
        entity: {
          id: null,
          dataType: null,
          property: null,
          name: null,
          tabName: null,
          cell: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          entityType: this.sheetDescLookupHeader,
          actualValue: null,
          parent: null
        },
        updateClicked: false,
        dropdownProperties: [
          'tarifftype',
          'mode',
          'transport',
          'bpper',
          'goods',
          'shipment',
          'rateper',
          'densitytype',
          'tariffbreakpointcosts1service',
          'distancetype',
          'breakpointsoff',
          'brandtype']
      }
    },
    watch: {
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          // this.$emit('updating', newVal)
        }
      },
      dets: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(this.details)) {
            this.details = newVal
          }
        }
      }
    },
    computed: {
      saveOrUpdate () {
        return this.entity.id !== null ? 'Update' : 'Save'
      },
      saveMethod () {
        return this.entity.id !== null ? 'put' : 'post'
      },
      saveUrl () {
        return this.entity.id ? API.UPDATE_ADMIN_ENTITY('spreadsheet-descriptor', this.entity.id) : API.CREATE_ADMIN_ENTITY('spreadsheet-descriptor')
      },
      isActualValue () {
        return this.getDataType(this.entity.dataType) === 'Actual Value'
      },
      isMainSpreadsheetField () {
        return !this.isActualValue && this.type === 'main'
      },
      useDropdownActualValue () {
        return this.dropdownProperties.includes(this.entity.property)
      },
      actualValueOptions () {
        if (this.entity.property === 'tariffbreakpointcosts1service') {
          return this.$store.getters['systemOption/serviceTypes']
        } else if (this.entity.property === 'tarifftype') {
          return this.getSystemOptions('LOOKUP_TYPE')
        } else if (this.entity.property === 'mode') {
          return this.getSystemOptions('MODE')
        } else if (this.entity.property === 'transport') {
          return this.getSystemOptions('TRANSPORT_TYPE')
        } else if (this.entity.property === 'bpper' || this.entity.property === 'rateper') {
          return this.getSystemOptions('BREAKPOINT_UNIT')
        } else if (this.entity.property === 'goods') {
          return this.getSystemOptions('GOODS_TYPE')
        } else if (this.entity.property === 'shipment') {
          return this.getSystemOptions('SHIPMENT_CATEGORY')
        } else if (this.entity.property === 'densitytype') {
          return this.getSystemOptions('UNIT_TYPE')
        } else if (this.entity.property === 'brandtype') {
          return this.getSystemOptions('BRAND')
        } else if (this.entity.property === 'distancetype') {
          return this.getSystemOptions('DISTANCE_TYPE')
        } else if (this.entity.property === 'breakpointsoff') {
          return [
            { code: 'Yes', name: 'Yes' },
            { code: 'No', name: 'No' }
          ]
        }
        return null
      }
    },
    methods: {
      updateActive ({ item, index }) {
        for (let prop in item) {
          this.entity[prop] = item[prop]
        }
      },
      getDataType (id) {
        if (id !== null) {
          let o = this.getSystemOption(id)
          return o && o.hasOwnProperty('name') ? o.name : ''
        }
        return ''
      },
      save () {
        if (!this.updateClicked) {
          this.updateClicked = true
          this.$http[this.saveMethod](this.saveUrl, { ...this.entity, entityType: this.sheetDescLookupHeader, parent: this.parent })
          .then(({data}) => {
            if (data.hasOwnProperty('id')) {
              this.entity.id = data.id
              this.addToList({ ...this.entity })
              event.$emit('toast', { type: 'success', message: 'Saved successfully' })
            }
          }).catch(err => {
            event.$emit('toast', { type: 'error', message: err.message })
            console.log(err)
          }).then(() => {
            this.updateClicked = false
          })
        }
      },
      addToList (de) {
        let i = this.details.findIndex(d => d.id === de.id)
        if (i === -1) {
          this.details.push(de)
        } else {
          for (let prop in de) {
            this.details[i][prop] = de[prop]
          }
        }
        this.doClear()
      },
      doClear () {
        this.$nextTick(() => this.updateActive({ item: this.getBaseData(), index: null }))
      },
      doDelete ({ item, index }) {
        this.$http.delete(API.DELETE_ADMIN_ENTITY('spreadsheet-descriptor', item.id))
        .then(res => {
          let i = this.details.findIndex(({id}) => id === item.id)
          if (i > -1) {
            this.details.splice(i, 1)
          }
          event.$emit('toast', { type: 'success', message: 'Item Deleted' })
          this.doClear()
        }).catch(err => {
          event.$emit('toast', { type: 'error', message: err.message })
          console.log(err)
        })
      },
      getBaseData () {
        return {
          id: null,
          dataType: null,
          property: null,
          name: null,
          tabName: null,
          cell: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          actualValue: null,
          entityType: this.sheetDescLookupHeader
        }
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/modules/admin/components/SpreadsheetDescriptor/BasicDetails.vue